var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getBreed } from '@spike/breed-utils';
import { getPetHairType } from '@spike/pets-action';
import capitalize from 'lodash/capitalize';
import moment from 'moment-timezone';
import isEmpty from 'lodash/isEmpty';
var convertFirstLetterToUpperCase = function (value) {
    return value
        .split(' ')
        .map(function (token) { return capitalize(token); })
        .join(' ');
};
export var convertToClient = function (masterData, timeZone, clientDto, showInactivePets) {
    var _a;
    return {
        id: clientDto.id,
        uuid: clientDto.uuid,
        firstName: clientDto.first_name,
        lastName: clientDto.last_name,
        email: clientDto.temporal_email ? '' : clientDto.email,
        phone: clientDto.phone,
        image: clientDto.image,
        pets: clientDto.pets
            ? clientDto.pets.reduce(function (pets, petDto) {
                if ((petDto.active && !petDto.deceased) || showInactivePets) {
                    pets.push(convertPet(masterData, timeZone, petDto));
                }
                return pets;
            }, [])
            : [],
        notes: clientDto.notes,
        active: clientDto.active,
        address: convertAddress(clientDto, masterData),
        authorizedContacts: clientDto.authorized_contacts
            ? clientDto.authorized_contacts.map(function (ap) { return convertContact(masterData, ap); })
            : [],
        temporalEmail: clientDto.temporal_email,
        tags: {
            positive: clientDto.marketing_positive_list
                ? masterData.clientTags.positive.filter(function (tag) { return clientDto.marketing_positive_list.includes(tag.id); })
                : [],
            negative: clientDto.marketing_negative_list
                ? masterData.clientTags.negative.filter(function (tag) { return clientDto.marketing_negative_list.includes(tag.id); })
                : [],
        },
        destroyable: clientDto.destroyable,
        notifications: {
            email: !clientDto.email_optout,
            phone: !clientDto.phone_optout,
            marketing: !clientDto.marketing_optout,
        },
        blocked: clientDto.blocked,
        customQuestionResponses: ((_a = clientDto.custom_question_responses) === null || _a === void 0 ? void 0 : _a.map(function (cqr) { return convertCustomQuestionResponse(cqr, timeZone); })) || [],
        hasActiveMembership: clientDto.has_active_membership,
    };
};
export var convertPet = function (masterData, timeZone, petDto) {
    return {
        id: petDto.id,
        name: petDto.name,
        type: masterData.petTypes.find(function (petType) { return petType.id === petDto.pet_type; }),
        breed: getBreed(petDto.pet_breed, petDto.pet_type, masterData),
        size: masterData.petSizes.find(function (v) { return v.element.id === petDto.pet_size; }).element,
        hair: getPetHairType(masterData, petDto.pet_type, petDto.pet_hair_type),
        totalVisits: petDto.visit_count,
        lastVisitDate: petDto.last_visit === null ? undefined : moment(petDto.last_visit).tz(timeZone),
        nextVisitDate: petDto.next_visit === null ? undefined : moment(petDto.next_visit).tz(timeZone),
        age: masterData.ageOptions.find(function (age) { return age.id === petDto.age; }),
        gender: masterData.petGenders.find(function (gender) { return gender.id === petDto.pet_gender; }),
        active: petDto.active,
        deceased: petDto.deceased,
        hasMedicalConditions: petDto.has_medical_history,
        imageUrl: petDto.image_url,
    };
};
export var convertContact = function (masterData, dto) {
    return {
        id: dto.id,
        uuid: dto.uuid,
        firstName: convertFirstLetterToUpperCase(dto.first_name),
        lastName: convertFirstLetterToUpperCase(dto.last_name),
        phone: dto.phone,
        relationship: masterData.relationships.find(function (r) { return r.id === dto.relationship_id; }),
        emergencyContact: dto.emergency_contact,
    };
};
export var convertAddress = function (clientDto, masterData) {
    if (clientDto.addresses && clientDto.addresses.length > 0) {
        var addressDto_1 = clientDto.addresses.reverse()[0];
        return {
            id: addressDto_1.id,
            street: addressDto_1.address_line_one,
            suite: addressDto_1.address_line_two,
            city: addressDto_1.city,
            state: addressDto_1.state,
            zipcode: addressDto_1.zipcode,
            country: masterData.countries.find(function (country) { return country.id === addressDto_1.country; }),
        };
    }
    else {
        return undefined;
    }
};
export var convertToSaveDto = function (marketplaceId, client, actualClient) {
    var _a;
    var id = client.id;
    return {
        id: id,
        marketplace_id: marketplaceId,
        uuid: client.uuid,
        first_name: client.firstName,
        last_name: client.lastName,
        email: client.temporalEmail && (!client.email || client.email.trim().length === 0)
            ? undefined
            : (_a = client.email) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase(),
        email_optout: !client.notifications.email,
        phone: client.phone,
        phone_optout: !client.notifications.phone,
        marketing_optout: !client.notifications.marketing,
        notes: client.notes,
        active: client.active,
        addresses_attributes: convertToAddressDto(marketplaceId, client, actualClient),
        image: client.image,
        regenerate_password: client.id === undefined,
        authorized_contacts_attributes: convertToAuthorizedContactsDto(client.authorizedContacts, actualClient),
        temporal_email: client.temporalEmail && (!client.email || client.email.trim().length === 0),
        marketing_positive_list: client.tags.positive.map(function (tag) { return tag.id; }),
        marketing_negative_list: client.tags.negative.map(function (tag) { return tag.id; }),
        blocked: client.blocked
    };
};
var convertToAddressDto = function (marketplaceId, client, actualClient) {
    var addresses = client.address
        ? [
            {
                id: client.address.id,
                marketplace_id: marketplaceId,
                address_line_one: client.address.street || '',
                address_line_two: client.address.suite || '',
                city: client.address.city || '',
                state: client.address.state || '',
                zipcode: client.address.zipcode || '',
                country: client.address.country.id,
                active: true,
            },
        ]
        : [];
    var removedAddresses = isEmpty(client.address) && !isEmpty(actualClient === null || actualClient === void 0 ? void 0 : actualClient.address) ? [{ id: actualClient.address.id, _destroy: true }] : [];
    return __spreadArray(__spreadArray([], addresses, true), removedAddresses, true);
};
export var convertToAuthorizedContactsDto = function (authorizedContacts, actualClient) {
    return __spreadArray(__spreadArray([], authorizedContacts.map(function (ap) { return convertToSaveContactDto(ap, actualClient === null || actualClient === void 0 ? void 0 : actualClient.id); }), true), ((actualClient === null || actualClient === void 0 ? void 0 : actualClient.authorizedContacts) || [])
        .filter(function (actualContact) { return !authorizedContacts.some(function (contact) { return contact.id === actualContact.id; }); })
        .map(function (actualContact) { return ({ id: actualContact.id, _destroy: true }); }), true);
};
var convertToSaveContactDto = function (contact, clientId) {
    var _a;
    return {
        id: contact.id,
        uuid: contact.uuid,
        customer_id: clientId,
        first_name: contact.firstName,
        last_name: contact.lastName,
        phone: contact.phone,
        relationship_id: (_a = contact.relationship) === null || _a === void 0 ? void 0 : _a.id,
        emergency_contact: contact.emergencyContact,
    };
};
var convertCustomQuestionResponse = function (cqr, timeZone) {
    return {
        id: cqr.id,
        answer: cqr.answer,
        question: cqr.question_snapshot,
        questionId: cqr.custom_question_id,
        responseableId: cqr.responseable_id,
        responseableType: cqr.responseable_type,
        updatedAt: moment(cqr.updated_at).tz(timeZone),
        createdAt: moment(cqr.created_at).tz(timeZone),
    };
};
